import PropTypes from 'prop-types';

import './ListingTitle.scss';

const roleLevelCorrelation = {
  primary: 'h1',
  secondary: 'h2',
  tertiary: 'h3'
};

const ListingTitle = props => {
  const ListingTitleTag =
    roleLevelCorrelation[props.role] || roleLevelCorrelation.secondary;

  return (
    <ListingTitleTag className="listing-title">
      {props.children}
    </ListingTitleTag>
  );
};
// To-DO: Fix ARIA type roles being propagated by listing title
ListingTitle.propTypes = {
  role: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
  children: PropTypes.node.isRequired
};

export default ListingTitle;
